import { render, staticRenderFns } from "./compatibility-notice.vue?vue&type=template&id=5aae857b&scoped=true&"
import script from "./compatibility-notice.vue?vue&type=script&lang=js&"
export * from "./compatibility-notice.vue?vue&type=script&lang=js&"
import style0 from "./compatibility-notice.vue?vue&type=style&index=0&id=5aae857b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae857b",
  null
  
)

export default component.exports